import { formatDateInZone } from "@nurion/datetime/format-date-in-zone";

import { LOCAL_ZONE } from "~/lib/relative-time";

// `now` is injectable so component tests stay deterministic.
export function formatRoomTime(ts: number, now: number = Date.now()): string {
  const tsDate = new Date(ts);
  const nowDate = new Date(now);
  const sameDay =
    tsDate.getFullYear() === nowDate.getFullYear() &&
    tsDate.getMonth() === nowDate.getMonth() &&
    tsDate.getDate() === nowDate.getDate();
  const iso = tsDate.toISOString();
  if (sameDay) {
    return formatDateInZone(iso, LOCAL_ZONE, { hour: "2-digit", minute: "2-digit" });
  }
  const yesterday = new Date(nowDate);
  yesterday.setDate(nowDate.getDate() - 1);
  if (
    tsDate.getFullYear() === yesterday.getFullYear() &&
    tsDate.getMonth() === yesterday.getMonth() &&
    tsDate.getDate() === yesterday.getDate()
  ) {
    return "Yesterday";
  }
  if (now - ts < 7 * 86_400_000) {
    return formatDateInZone(iso, LOCAL_ZONE, { weekday: "short" });
  }
  return formatDateInZone(iso, LOCAL_ZONE, { month: "short", day: "numeric" });
}
